export const REFRESH_REPORTS_DETAIL = 'REFRESH_REPORTS_DETAIL';

export const refreshReportDetail = (reportId, reportData) => ({
  type: REFRESH_REPORTS_DETAIL,
  reportId,
  reportData
});



// WEBPACK FOOTER //
// ./src/actions/reportDetail.js